module.exports = __webpack_public_path__ + "static/media/eating-habits.7929ce06.svg";